var map = {
	"./assassin.jpg": "2522",
	"./back.jpg": "7851",
	"./believers.jpg": "b4d4",
	"./bomber.jpg": "393c",
	"./boy.jpg": "b618",
	"./cinderellaGirl.jpg": "b54e",
	"./crab.jpg": "a6e0",
	"./dancer.jpg": "3d3d",
	"./daughter.jpg": "6696",
	"./doctor.jpg": "6150",
	"./godfather.jpg": "05f6",
	"./investigator.jpg": "e409",
	"./killer.jpg": "32f7",
	"./mafia.jpg": "9721",
	"./nobleman.jpg": "3098",
	"./people.jpg": "7ca0",
	"./pickpocket.jpg": "0c21",
	"./police.jpg": "9355",
	"./prostitute.jpg": "dc77",
	"./sniper.jpg": "2dff",
	"./survivor.jpg": "b4d6",
	"./traitor.jpg": "e105",
	"./trickster.jpg": "1e85"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2536";